import React, { useEffect, useState } from "react";
import { Delete, Pen } from "lucide-react";
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import AssetsFormPage from "./assets_form";
import { addAsset, deleteAsset, fetchAssets, updateAsset } from "../../../slices/company/assetsSlice";
import moment from "moment";
import { customTableStyles } from "../../../utils/tableStylings";

const AssetsPage = () => {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false); // To control modal visibility
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [modalHeading, setModalHeading] = useState('');
    const { assets } = useSelector(state => state.assets);

    useEffect(() => {
        const company = JSON.parse(localStorage.getItem('company'));
        if (company) {
            const companyId = company.company?.id;
            dispatch(fetchAssets(companyId));
        }
    }, [dispatch]);

    const handleFormSubmit = (formData) => {
        if (selectedCustomer && selectedCustomer?.id != null) {
            dispatch(updateAsset({ id: selectedCustomer.id, updatedData: formData }));

        } else {

            const company = JSON.parse(localStorage.getItem('company'));
            const companyId = company.company?.id;
            const newFormData = { ...formData, company_id: companyId };
            dispatch(addAsset(newFormData));
        }
        setShowModal(false);
    };


    const handleEditTax = (unitdata) => {
        setSelectedCustomer(unitdata);
        setModalHeading('Edit Assets') // Pass the supplier data to edit
        setShowModal(true);
    };

    const handleDelete = (taxId) => {
        Swal.fire({
            title: '<strong>Are you sure?</strong>',
            html: `<p>This action will <b>permanently delete</b> this asset.</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteAsset(taxId));
                Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'The Asset has been deleted.',
                    toast: true,          // Enable toast style
                    position: 'top-end',  // Position at the top-right corner
                    showConfirmButton: false,  // Hide the confirm button
                    timer: 3000,          // Set the timer to auto-close after 3 seconds
                    timerProgressBar: true,  // Show the progress bar for the timer
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer);
                        toast.addEventListener('mouseleave', Swal.resumeTimer);
                    }
                });

            }
        });

    };


    const unitColumn = [
        {
            name: '#',
            cell: (row, index) => index + 1, // Show index of the row
            width: '50px'
        },
        {
            name: 'Name',
            selector: row => row.item_name,
            sortable: true
        },
        {
            name: 'Quantity',
            selector: row => row.quantity,
            sortable: true
        },
        {
            name: 'Price',
            selector: row => row.amount,
            sortable: true
        },
        {
            name: 'Comment',
            selector: row => row.comment,
            sortable: true
        },
        {
            name: 'Purchase Date',
            selector: row => moment(row.purchase_date).format("DD MMMM, YYYY"),
            sortable: true
        },
        {
            name: 'Is Disposal',
            selector: row => (
                row.is_disposal == 1 ?
                    <span className="badge bg-danger">Disposed</span> :
                    <span className="badge bg-success">No</span>
            ),
            sortable: true
        },
        {
            name: 'Actions',
            cell: row => (
                <>
                    <span
                        className="text-warning cursor-pointer me-2"
                        onClick={() => handleEditTax(row)}
                    >
                        <Pen />
                    </span>
                    <span
                        className="text-danger cursor-pointer"
                        onClick={() => handleDelete(row.id)}
                    >
                        <Delete />
                    </span>
                </>
            ),
            width: '150px'
        }
    ];

    const handleAdd = () => {
        setSelectedCustomer([]);
        setModalHeading('Create Asset');// No supplier means we are adding a new one
        setShowModal(true);
    };



    return (
        <>
            <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center mb-3">
                    <h2>Assets</h2>
                    <button
                        className="btn btn-primary"
                        onClick={() => handleAdd()}
                    >
                        + Add New
                    </button>
                </div>
                <div className="card-body">
                    <DataTable

                        columns={unitColumn}
                        data={assets}
                        pagination
                        highlightOnHover
                        striped
                        dense
                        customStyles={customTableStyles}
                    />
                </div>
            </div>
            <AssetsFormPage show={showModal} onClose={() => setShowModal(false)} heading={modalHeading} initialData={selectedCustomer} onSubmit={handleFormSubmit} />
        </>
    );
}

export default AssetsPage;